import React, { useState, useEffect } from "react";
import "./PhotosGallery.css";

// Import your images here - replace these with your actual image imports
import image1 from "../../assets/images/socis/imatge1.jpg";
import image2 from "../../assets/images/socis/imatge2.jpg";
import image3 from "../../assets/images/socis/imatge3.jpg";
import image4 from "../../assets/images/socis/imatge4.jpg";

function PhotosGallery() {
  const [activeIndex, setActiveIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    return () => {
      window.removeEventListener("resize", checkIfMobile);
    };
  }, []);

  const handleMouseEnter = (index) => {
    if (!isMobile) {
      setActiveIndex(index);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setActiveIndex(null);
    }
  };

  const handleClick = (index) => {
    if (isMobile) {
      setActiveIndex(activeIndex === index ? null : index);
    }
  };

  return (
    <div className="photos-gallery">
      <div
        className={`photos-gallery__item ${activeIndex === 0 ? "active" : ""}`}
        onMouseEnter={() => handleMouseEnter(0)}
        onMouseLeave={handleMouseLeave}
        onClick={() => handleClick(0)}
      >
        <img src={image1} alt="Gallery 1" />
      </div>

      <div
        className={`photos-gallery__item ${activeIndex === 1 ? "active" : ""}`}
        onMouseEnter={() => handleMouseEnter(1)}
        onMouseLeave={handleMouseLeave}
        onClick={() => handleClick(1)}
      >
        <img src={image2} alt="Gallery 2" />
      </div>

      <div
        className={`photos-gallery__item ${activeIndex === 2 ? "active" : ""}`}
        onMouseEnter={() => handleMouseEnter(2)}
        onMouseLeave={handleMouseLeave}
        onClick={() => handleClick(2)}
      >
        <img src={image3} alt="Gallery 3" />
      </div>

      <div
        className={`photos-gallery__item ${activeIndex === 3 ? "active" : ""}`}
        onMouseEnter={() => handleMouseEnter(3)}
        onMouseLeave={handleMouseLeave}
        onClick={() => handleClick(3)}
      >
        <img src={image4} alt="Gallery 4" />
      </div>
    </div>
  );
}

export default PhotosGallery;
